module.exports = __webpack_public_path__ + "static/media/man in suit_rome.cdcfb10a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/man in suit_rome.jpg
// module id = 420
// module chunks = 0